import type { FC, ForwardedRef, ReactNode } from "react";
import { useState } from "react";

import { Box, Flex } from "@similarweb/ui-components/foundations";

import { CollapsibleSectionHeader } from "./CollapsibleSectionHeader";

interface ICollapsiblePromptsListProps {
    title: string;
    children: ReactNode;
    defaultExpanded?: boolean;
    listRef?: ForwardedRef<HTMLDivElement>;
}

export const CollapsiblePromptsList: FC<ICollapsiblePromptsListProps> = ({
    title,
    children,
    defaultExpanded = true,
    listRef,
}) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    return (
        <Flex
            flexDirection="column"
            height="100%"
            overflow="hidden"
        >
            <CollapsibleSectionHeader
                title={title}
                isExpanded={isExpanded}
                onToggle={() => setIsExpanded(!isExpanded)}
            />
            {isExpanded ? (
                <Flex
                    ref={listRef}
                    flexDirection="column"
                    overflowY="auto"
                    flex="1"
                    minHeight="0"
                    gap="15px"
                    margin="16px 0 0 0"
                >
                    {children}
                </Flex>
            ) : null}
        </Flex>
    );
};
